import { List, ThemeIcon } from '@mantine/core'
import { forwardRef } from 'react'
import type { Props } from '../node/definition'
import IconSvg from '@packages/icon-svg'

function ListItems(p: Props) {
	const { listScheme } = p

	return listScheme?.map((i: any) => { 
		return (
			<List.Item
				key={String(Math.random())}
				icon={
					i.icon && (
						<ThemeIcon color={i.icon.color || 'transparent'} size={i.icon.size || 24} radius={i.icon.radius || 'xl'}>
							<IconSvg
								iconName={i.icon.name || 'point-filled'}
								iconStroke={i.icon.stroke || 2}
								iconColor={i.icon.iconColor || 'dark'}
								iconSize={i.icon.iconSize || 14}
							/>
						</ThemeIcon>
					)
				}
			>
				{i.title}
				{i.subScheme?.length && (
					<List {...p} {...p.customProps}>
						{/* Передаём тип и другие пропсы вниз */}
						<ListItems {...p} {...p.customProps} listScheme={i.subScheme} /> {/* Рекурсивный вызов */}
					</List>
				)}
			</List.Item>
		)
	})
}

export default forwardRef((p: Props) => {
	return (
		<List {...p} {...p.customProps} >
			{p.listScheme?.length && <ListItems {...p} />}
		</List>
	)
})

